export default __webpack_public_path__ + "locales/en/Settings.json?hash=50cbf84bd8a7d8e25a542a3337dcceb1";